/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Exocet Motion — unified GSAP refresh hub
 */
(function () {
  "use strict";

  // Central plugin registration: runs once at module parse time.
  // All other motion files rely on this and must NOT call gsap.registerPlugin themselves.
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
    // SplitText (3.13) is optional — handcrafted text reveals degrade gracefully if it is absent.
    if (typeof SplitText !== "undefined") gsap.registerPlugin(SplitText);
    // ignoreMobileResize: the iOS address bar show/hide fires resize and would jump
    // top-X% reveal start points; fastScrollEnd settles flings so onComplete is not missed.
    ScrollTrigger.config({ ignoreMobileResize: true, fastScrollEnd: true });
  }

  var modules = [];

  function refreshAll() {
    modules.forEach(function (mod) {
      if (mod && typeof mod.refresh === "function") {
        try {
          mod.refresh();
        } catch (err) {
          console.warn("[ExocetMotion] refresh failed", err);
        }
      }
    });

    var header = document.querySelector("[data-header-2026]");
    if (header && header._scrollMotion && typeof header._scrollMotion.refresh === "function") {
      header._scrollMotion.refresh();
    }

    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  }

  window.ExocetMotion = {
    register: function (api) {
      if (api) modules.push(api);
    },
    refresh: refreshAll,
    supports: function () {
      return typeof gsap !== "undefined";
    },
  };

  window.addEventListener(
    "load",
    function () {
      refreshAll();
    },
    { once: true },
  );

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:reorder", refreshAll);
  }
})();
